module.exports = __webpack_public_path__ + "media/images/icons/dropdown-circle-icon-9a70040ba1934b31d947e415a64da779.svg";